export function StopCircleIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.5"
        d="M17.8334 10.0001C17.8334 14.3263 14.3262 17.8334 10 17.8334C5.67379 17.8334 2.16669 14.3263 2.16669 10.0001C2.16669 5.67385 5.67379 2.16675 10 2.16675C14.3262 2.16675 17.8334 5.67385 17.8334 10.0001Z"
        stroke="currentColor"
      />
      <path
        d="M7.15485 7.15491C6.66669 7.64306 6.66669 8.42875 6.66669 10.0001C6.66669 11.5714 6.66669 12.3571 7.15485 12.8452C7.643 13.3334 8.42869 13.3334 10 13.3334C11.5714 13.3334 12.357 13.3334 12.8452 12.8452C13.3334 12.3571 13.3334 11.5714 13.3334 10.0001C13.3334 8.42875 13.3334 7.64306 12.8452 7.15491C12.357 6.66675 11.5714 6.66675 10 6.66675C8.42869 6.66675 7.643 6.66675 7.15485 7.15491Z"
        fill="currentColor"
      />
    </svg>
  );
}
